export { CustomTabLabel } from './CustomTabLabel';
